export default "__VITE_ASSET__B9snXs4F__"